'use client';
import type { ReactNode } from 'react';
import i18n from '@/lib/i18n';

export function I18nProvider({ children, locale }: { children: ReactNode; locale?: string }) {
  // Synchroniczny changeLanguage — przed first render eliminuje SSR↔client mismatch.
  // NIE w useEffect (zbyt późno).
  if (locale && i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }
  return <>{children}</>;
}
